import {
  getProducts,
  getCategoryBrandList
} from '@/apis/base';

const PAGE_SIZE = 20;
const PAGE_INDEX = 1;

export default {
  namespaced: true,
  state: () => {
    return {
      classList: [],
      product: {
        list: [],
        pageInfo: {
          pageIndex: PAGE_INDEX,
          pageSize: PAGE_SIZE
        }
      },
      currentBrandId: '-1',
      currentClassId: '1'
    };
  },
  mutations: {
    setClassList (state, payload) {
      state.classList = payload;
    },
    setProducts (state, payload) {
      state.product.list = payload;
    },
    setClassId (state, payload) {
      state.currentClassId = payload;
    },
    setPageInfo (state, payload) {
      state.product.pageInfo = payload;
    },
    setBrandId (state, payload) {
      state.currentBrandId = payload;
    }
  },
  actions: {
    async fetchNavData ({ commit, dispatch }, { classId, brandId }) {
      try {
        let res = await getCategoryBrandList();
        commit('setClassList', res._data.classList);
        if (!classId) classId = res._data.classList[0]['classId'];
        if (!brandId) brandId = res._data.classList[0]['brandList'][0]['brandId'];
        commit('setClassId', classId);
        commit('setBrandId', brandId);
        dispatch('getProductList');
      } catch (e) {
        console.log(e);
      }
    },
    async getProductList ({ commit, state }) {
      const classId = state.currentClassId;
      const brandId = state.currentBrandId;
      const { pageIndex, pageSize } = state.product.pageInfo;
      try {
        const res = await getProducts(classId, brandId, pageIndex, pageSize);
        const list = res._data.productList;
        const pageInfo = res._data.pageInfo;
        commit('setProducts', list);
        commit('setPageInfo', pageInfo);
      } catch (e) {
        console.log(e);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/navData/store.js